import React from "react";
import { lineasDeRecordatorio } from "./recordatorios";
import "./RecordatorioLineas.css";

/* One line per delivery channel of a reservation's `reminder`, for the detail of every vertical's agenda.
   Renders nothing when there is no line (reminder null), so callers can drop it in unconditionally. */

const RecordatorioLineas = ({ reminder, className = "" }) => {
  const lineas = lineasDeRecordatorio(reminder);
  if (!lineas.length) return null;
  return (
    <div className={`zr-recordatorios ${className}`.trim()} data-testid="recordatorio-lineas">
      {lineas.map((linea) => (
        <div key={linea.name}>{linea.text}</div>
      ))}
    </div>
  );
};

export default RecordatorioLineas;
